<template>
    <div class="sa-tab-scroll">
        <b-card class="sa-card" header="Data Evento" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">{{ this.getLabelTraduora("patient.cardiology.lblEventDate") }}</label>
                    <date-picker format="DD-MM-YYYY HH:mm" value-type="timestamp" v-model="jsonData.dataEvento" type="datetime" disabled></date-picker>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="Diagnosi" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Categoria</label>
                    <b-form-select v-model="jsonData.categoriaDiagnosi" :options="categoriaDiagnosiOptions" value-field="categoria" text-field="descrizione" @change="onChangeCategoriaDiagnosi"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Diagnosi</label>
                    <b-form-select v-model="jsonData.diagnosi" :options="diagnosiOptions" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Altro</label>
                    <vue-editor class="sa-qeditor" :editor-toolbar="customToolbar" v-model="jsonData.diagnonsiAltro" style="height: 250px" :disabled="jsonData.diagnosi !== 'ALTRO'" />
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="Trattamento" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Trattamento</label>
                    <b-form-select v-model="jsonData.idPrestazione" :options="prestazioniOptions" value-field="idTrattamento" text-field="nomeTrattamento" @change="onChangeTrattamento"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Prezzo</label>
                    <b-form-input v-model="jsonData.prezzoPrestazione" disabled type="number"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="Refertazione" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <!-- <label class="sa-flexbox-body-title">Conclusioni</label> -->
                    <eventi-dizionari-component :tipoEvento="tipoEvento" :gruppo="gruppo" tipoDizionario="CONCLUSIONI" @update="onUpdateConclusioni"></eventi-dizionari-component>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <vue-editor class="sa-qeditor" :editor-toolbar="customToolbar" v-model="jsonData.note" style="height: 250px" />
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import UtilityMixin from "../../../../../utility/UtilityMixin";
// import { VueEditor } from "vue2-editor";
import EventiDizionariComponent from "../../../base/components/EventiDizionariComponent.vue";
export default {
    components: { DatePicker, EventiDizionariComponent },
    mixins: [UtilityMixin],

    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
        jsonData: {
            type: Object,
            default: function () {
                return {
                    note: "",
                    dataEvento: new Date().getTime(),
                };
            },
        },
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        let sessionStorage = window.sessionStorage;
        let idPrenotazione = sessionStorage.getItem("idPrenotazione");
        me.jsonData.idAccettazione = this.$route.query.idAccettazione;
        me.jsonData.idPrenotazione = idPrenotazione;
        me.jsonData.dataEvento = new Date().getTime();
        me.loadPrestazioni();
        me.loadCategorieDiagnosi();
        me.loadData();
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
        currentPage() {
            let me = this;
            me.loadDatiPacs();
        },
    },
    data() {
        return {
            rows: 0,
            currentPage: 1,
            perPage: 10,
            pathResource: "/visitabotox",
            pathResourcePrestazioni: "/externalprenotazioni/trattamenti",
            pathResourceCategorieDiagnosi: "/botoxdiagnosicategorie",
            pathResourceDiagnosi: "/botoxdiagnosi",
            tipoEvento: "VISITA BOTOX",
            gruppo: "BOTOX",
            isDisalble: false,
            linkPacs: "",
            id: "-1",
            idRisorsa: null,
            diagnosiOptions: [{ value: "", text: "-Seleziona Valore-" }],
            categoriaDiagnosiOptions: [],
            disableCampi: false,
            listaRichieste: [],
            prestazioniOptions: [],
            customToolbar: [
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            ],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Data Ora",
                    key: "dataOraResponse",
                    formatter: function (value) {
                        return moment(new Date(value)).format("DD-MM-YYYY HH:mm");
                    },
                },
                { class: "sa-table-column-action-single", key: "actions", label: "", thStyle: "width: 8rem" },
            ],
        };
    },
    methods: {
        loadData() {
            let me = this;
            this.$emit("beforeLoadData");
            if (me.id === "-1") {
                this.$emit("afterLoadData");
            } else {
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.id;
                axios.get(link).then((response) => {
                    this.$emit("update", response.data.data);
                    if (response.data.data.categoriaDiagnosi !== null && response.data.data.categoriaDiagnosi !== "") {
                        me.onChangeCategoriaDiagnosi();
                    }
                    this.$emit("afterLoadData");
                });
            }
        },
        loadPrestazioni() {
            let me = this;
            this.loadDataResources(me.pathResourcePrestazioni, null, me.loadPrestazioniSuccess, me.loadPrestazioniError);
        },
        loadPrestazioniSuccess(response) {
            let me = this;
            me.prestazioniOptions = response.data.data;
            me.prestazioniOptions.unshift({ idTrattamento: "", nomeTrattamento: "-Seleziona Valore-" });
        },
        loadPrestazioniError() {},
        onUpdateBase64() {},
        onUpdateLista(data) {
            let me = this;
            me.listaRichieste = data;
            if (me.listaRichieste.length > 0) {
                me.disableCampi = true;
                if (me.listaRichieste[0].statoAttuale !== "IN VISITA") {
                    me.disableCampi = false;
                }
            }
        },
        onVisualizza(id) {
            let me = this;
            me.isDisalble = false;
            let link = process.env.VUE_APP_PATH_API + me.pathPacsEndpoint + id;
            axios
                .get(link)
                .then((response) => {
                    me.linkPacs = "";
                    me.linkPacs = response.data.data.url;
                    // console.log(me.linkPacs);
                })
                .catch((error) => {
                    this.$emit("afterLoadData");
                    this.$bvModal
                        .msgBoxOk(error.response.data.messaggio, {
                            title: "ATTENZIONE",
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then((value) => {
                            console.log(value);
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                });
        },
        onClose() {
            let me = this;
            me.linkPacs = "";
        },
        onUpdateConclusioni(data) {
            let me = this;
            me.jsonData.note = data;
            this.$emit("update", me.jsonData);
        },
        onChangeTrattamento() {
            let me = this;
            me.prestazioniOptions.forEach((element) => {
                if (element.idTrattamento === me.jsonData.idPrestazione) {
                    me.jsonData.prezzoPrestazione = element.prezzo;
                    me.jsonData.prestazione = element.nomeTrattamento;
                }
            });
        },
        loadCategorieDiagnosi() {
            let me = this;
            this.loadDataResources(me.pathResourceCategorieDiagnosi, null, me.loadCategorieDiagnosiSuccess, me.loadCategorieDiagnosiError);
        },
        loadCategorieDiagnosiSuccess(response) {
            let me = this;
            me.categoriaDiagnosiOptions = response.data.data.list;
            me.categoriaDiagnosiOptions.unshift({ categoria: "", descrizione: "-Seleziona Valore-" });
        },
        loadCategorieDiagnosiError() {},
        onChangeCategoriaDiagnosi() {
            let me = this;
            let filtro = { codiceCategoria: me.jsonData.categoriaDiagnosi };
            this.loadDataResources(me.pathResourceDiagnosi, filtro, me.loadDiagnosiSuccess, me.loadDiagnosiError);
        },
        loadDiagnosiSuccess(response) {
            let me = this;
            me.diagnosiOptions = [];
            response.data.data.list.forEach((element) => {
                me.diagnosiOptions.push({ value: element.diagnosi, text: element.diagnosi });
            });
            me.diagnosiOptions.unshift({ value: "", text: "-Seleziona Valore-" });
        },
        loadDiagnosiError() {},
    },
};
</script>

<style></style>
